export enum OrderStatus {
    Ordered = 'Ordered',
    PartiallyAttempted = 'PartiallyAttempted',
    Attempted = 'Attempted',
    Canceled = 'Canceled'
}
